import React, {forwardRef, useEffect, useImperativeHandle, useMemo, useRef, useState} from "react";
import {
    Button,
    ConfigProvider,
    Dropdown,
    Input,
    message,
    Modal,
    Select,
    Space,
    Spin,
    Tabs,
    Tooltip,
    Tree,
    TreeDataNode
} from "antd";
import {useTranslation} from "react-i18next";
import Icon, {CaretDownOutlined, DeleteOutlined, MoreOutlined} from "@ant-design/icons";
import {TreeProps} from "antd/es/tree";
import {
    createCopyLink,
    createCopyLinkByLibraryItem, decodeDeeplink,
    generateRandomPageKey, generateUUID2, getFileNameWithoutExt, getImagePathWithTheme, getItem, getLocalFilePath,
    getNoteFirstHtmlForLeftCard, getPdfImageThumb, getVideoImageThumb, hasDesktopBaseLicense, hasLicense,
    imgPathPerfix, isAbsoluteFilePath, isAudio, isDarkMode, isDeepLink, isImage, isMarkdown, isPdf,
    isPdfFileElement, isString,
    isStringNullOrEmpty, isVideo,
    jsonToStringReplaceIcon
} from "@/utils";
import {
    EVENT_CHOOSE_INSERT_PDF_FILE,
    EVENT_MINDMAP_LINK_INFO,
    EVENT_REFRESH_LIBRARY_LIST,
    FROM_ADD,
    FROM_DIALOG,
    FROM_LIBRARY,
    FROM_LINK_TO_PROJECT,
    KEY_LINK_CARD_TAB,
    KEY_LINK_TAB,
    LINK_INFO_TYPE_FRAME,
    LINK_INFO_TYPE_NOTE,
    LINK_INFO_TYPE_PAGE,
    LINK_INFO_TYPE_PDF,
    LINK_INFO_TYPE_URL, MAX_Z_INDEX
} from "@/Const";
import {
    IconBoard,
    IconClose,
    IconCloseBlack,
    IconDropdownBlack,
    IconDropdownGray,
    IconFrame,
    IconPageBlack,
    IconPageCheck, IconPdf, IconTreeFolderCollapse, IconTreeFolderExpand
} from "@/Icon";
import DialogMessageBox from "@/common/DialogMessageBox";
import {isEmbeddableElement} from "../../../@excalidraw/packages/excalidraw/element/typeChecks";
import {APP_WEB, APP_WEB_WWW} from "@/electron_interactive";
import {ipcInvoke, ipcSend} from "@/common/ipc";
import {postMessage} from "@/common/event";
import PageLibrary from "@/views/Library/PageLibrary";
import Global from "@/global";
import {openEditor} from "@/state";
import {t} from "i18next";
import DirectoryTree from "antd/es/tree/DirectoryTree";
import {getNoteJsonDoc, getNoteList} from "@model/note";
import {beyondFreePdfLimit, beyondFreeVideoLimit, getScheme} from "@/Utility";
import {isZh} from "@/language";
import {getCardById, getLibraryByFileName, updateCard} from "@model/card";
import {PROJECT_ID} from "@/views/Draw/DrawIndex";
import global from "@/global";
import {KEYS} from "../../../@excalidraw/packages/excalidraw/keys";
import {isValidUrl} from "../../../@excalidraw/packages/excalidraw/data/url";
import {loopAllNode} from "@/TreeUtils";
import {debugLog} from "@/LogUtils";

let mArrayPages:any = [];
let mArrayNotes:any = [];
let mArrayPdfs:any = [];
let mszInputUrl:any = '';
let mElement:any;
let mPageId:any;
let mPdfPageId:any;
let mArrayAllTreeData:any;
let mTabKey:any;
let mIsFolder:boolean = false;

const DialogLink = forwardRef((props:{isShowDialog:boolean,onCloseDialog:any,onInsertLink:any}, ref) => {
    useImperativeHandle(ref,()=>({onSetTreeData:onSetTreeData,onShowDialog:onShowDialog}))
    const {t} = useTranslation();
    const dialogMessageBoxRef = useRef(null);
    const [tabKey,setTableKey] = useState('pages');
    const [expandPagesKeys, setExpandPagesKeys] = useState([]);
    const [treePageSelectedKeys, setTreePageSelectedKeys] = useState(['']);
    const [treeNoteSelectedKeys, setTreeNoteSelectedKeys] = useState(['']);
    const [treeFrameSelectedKeys, setTreeFrameSelectedKeys] = useState(['']);
    const [treePdfSelectedKeys, setTreePdfSelectedKeys] = useState(['']);
    const [arrayPagesData,setArrayPagesData] = useState([]);
    const [arrayPagesPdfData,setArrayPagesPdfData] = useState<any>([]);
    const [arrayFramesData,setArrayFramesData] = useState([]);
    const [arrayNotesData,setArrayNotesData] = useState<any>([]);
    const [arrayPdfsData,setArrayPdfsData] = useState([])
    const [autoExpandPagesParent, setAutoExpandPagesParent] = useState(false);
    const [inputUrl,setInputUrl] = useState(mszInputUrl);
    const [isShowPageSelected,setIsShowPageSelected] = useState(true);
    const [hasLink,setHasLink] = useState(false);
    const {DirectoryTree} = Tree;
    const [framePageValue,setFramePageValue] = useState(t('Current board'));
    const [pdfPageValue,setPdfPageValue] = useState(t('Current board'));
    const [isShowPageLibrary,setIsShowPageLibrary] = useState(false);
    const [libraryType,setLibraryType] = useState('card');
    const [from,setFrom] = useState(null);
    const [extra,setExtra] = useState(null);
    const [isSearching,setIsSearching] = useState(false);

    const [arrayTreeData,setArrayTreeData] = useState([]);
    const mArrayFrames = useRef<any>([]);

    const pageLibraryRef = useRef(null);
    const inputRef = useRef(null);
    const mLastSearchTimeoutId = useRef<any>(null);

    const tabItems = [
        {
            key:'pages',
            label:t('Boards'),
            children:''
        },
        {
            key:'frames',
            label:t('Frames'),
            children:''
        },
        // {
        //     key:'notes',
        //     label:t('Notes'),
        //     children:''
        // },
        // {
        //     key:'pdfs',
        //     label:t('PDF'),
        //     children:''
        // }
        {
            key:'project',
            label:t('Projects'),
            children:''
        },
        {
            key:'library',
            label:t('Library'),
            children:''
        },
    ]

    const tabItemsFromCard = [
        {
            key:'project',
            label:t('Projects'),
            children:''
        },
        {
            key:'library',
            label:t('Library'),
            children:''
        },
    ]

    const MENU = [
        getItem(t("Local file"), 'file', null, undefined, undefined, (e) => {
            ipcInvoke('getFilePath', {}).then(res => {
                mIsFolder = false;
                setInputUrl(res);
            })
        }),
        getItem(t("Local folder"), 'folder', null, undefined, undefined, (e) => {
            ipcInvoke('open-select-dir').then(res=>{
                mIsFolder = true;
                setInputUrl(res);
            })
        }),
    ]

    /**
     * 监听回车
     * @param event
     */
    function onKeydown(e){
        // debugLog('onkeydown',e)
        if (e.key == KEYS.ENTER){
            onSaveLink();
        }
    }

    useEffect(()=>{
        mszInputUrl = '';
        setInputUrl('');
        global.g_isDialogLink = true;
        global.g_showDialogs['dialogLink'] = true;

        setTimeout(()=>{
            inputRef.current?.focus();
        },200);

        return ()=>{
            global.g_isDialogLink = false;
            global.g_showDialogs['dialogLink'] = false;
        }
    },[])

    useEffect(()=>{
        document.body.addEventListener('keydown',onKeydown);
        return ()=>{
            document.body.removeEventListener('keydown',onKeydown);
        }
    });

    /**
     * 直接添加到库
     * @param szFilePath
     */
    const insertLibraryByLinkMode = async (szFilePath:any)=>{
        if (!isAbsoluteFilePath(szFilePath))return;
        if (isVideo(szFilePath)){
            let nVideoCount = await beyondFreeVideoLimit();
            if (!hasLicense() && !hasDesktopBaseLicense() && nVideoCount){
                window.showMessageBox(t("Upgrade required"), t("NeedUpgradeToImportVideoMore"), t("Cancel"), t("Learn more"), null, () => {
                    if (isZh()) {
                        ipcSend('open-url',import.meta.env.VITE_HTTP_PURCHASE_PRICE_ZH)
                    }else {
                        ipcSend('open-url', import.meta.env.VITE_HTTP_PURCHASE_PRICE);
                    }
                })
                return;
            }
        }else if (isPdf(szFilePath)){
            let nPdfCount = await beyondFreePdfLimit();
            if (!hasLicense() && !hasDesktopBaseLicense() && nPdfCount){
                window.showMessageBox(t("Upgrade required"), t("NeedUpgradeToImportPDF"), t("Cancel"), t("Learn more"), null, () => {
                    if (isZh()) {
                        ipcSend('open-url',import.meta.env.VITE_HTTP_PURCHASE_PRICE_ZH)
                    }else {
                        ipcSend('open-url', import.meta.env.VITE_HTTP_PURCHASE_PRICE);
                    }
                })
                return;
            }
        }
        // if (isMarkdown(szFilePath)){
        //     window.importMarkdown(selectedFile,()=>{
        //         //刷新列表
        //
        //     });
        //     return;
        // }

        let szImgBase64:any = '';
        let szType = 'file';
        if (isPdf(szFilePath)){
            szImgBase64 = await getPdfImageThumb(getLocalFilePath(szFilePath,true));
            szType = 'pdf'
        }else if (isVideo(szFilePath)){
            szImgBase64 = await getVideoImageThumb(getLocalFilePath(szFilePath,true));
            szType = 'video'
        }else if (isImage(szFilePath)){
            szType = 'image'
        }else if (isAudio(szFilePath)){
            szType = 'audio'
        }

        const id = generateUUID2();
        //缩略图保存为文件
        let szSrc = '';
        if (szImgBase64){
            const szFileName = id + ".png";
            await ipcInvoke('write-base64-image',{fileName:szFileName,imgBase64:szImgBase64});
            szSrc = getScheme()+szFileName;
        }

        const item = {
            id:id,
            name:getFileNameWithoutExt(szFilePath),
            fileName:szFilePath,
            type:szType,
            thumbImage:szSrc,
            isAbsolutePath:true,
            createTime:Date.now()
        }
        await updateCard(item);
        postMessage(EVENT_REFRESH_LIBRARY_LIST);
        return item;
    }


    /**
     * 设置数据
     * @param arrayPagesData
     * @param arrayNotesData
     */
    const onSetTreeData = (arrayPagesData,arrayNotesData,linkInfo:any,element:any,arraySelectedKeys:any,from:any)=>{
        setIsShowPageSelected(true)
        setFrom(from);
        const szPagesData = jsonToStringReplaceIcon(arrayPagesData);
        const arrayNewPagesData = JSON.parse(szPagesData);

        let firstPage:any = null;
        loopAllNode(arrayNewPagesData,(node)=>{
            node.isSelected = false;
            node.icon = <IconPageBlack/>
            if (!firstPage && node.drawJson){
                firstPage = node;
            }
        })
        // for (let i=0;i<arrayNewPagesData.length;i++) {
        //     arrayNewPagesData[i].isSelected = false;
        //     arrayNewPagesData[i].icon = <IconPageBlack/>
        // }

        mArrayPages = [...arrayNewPagesData];
        mArrayNotes = arrayNotesData;
        mElement = element;
        let selectKey = '';
        if (arraySelectedKeys.length > 0){
            selectKey = arraySelectedKeys[0];
        }

        mArrayPages.forEach(p=>{
            p.value = p.key;
            p.label = p.title;
            p.showLabel = p.title;
            if (p.key == selectKey){
                p.showLabel = t("Current board");
            }
        })

        if (firstPage){
            setPageFrameTree(firstPage);
            setPagePdfTree(firstPage);
        }

        setIsShowPageLibrary(false);
        let szTabKey:any = localStorage.getItem(KEY_LINK_TAB) || 'pages';
        // if (isStringNullOrEmpty(szTabKey)){
        //     szTabKey = 'pages';
        // }else {
        //     if (szTabKey == 'notes'){
        //         setIsShowPageLibrary(true);
        //         setLibraryType('card');
        //     }else if (szTabKey == 'pdfs'){
        //         setIsShowPageLibrary(true);
        //         setLibraryType('pdf');
        //     }
        // }
        // if (element?.frameId){
        //     szTabKey = 'frames';
        // }else{
        //     szTabKey = 'pages';
        // }
        setTableKey(szTabKey);
        mTabKey = szTabKey;

        if(linkInfo != undefined && !isString(linkInfo)){
            setHasLink(true);
            mszInputUrl = (linkInfo.url);
            if (linkInfo.type == LINK_INFO_TYPE_PAGE){
                setTableKey('pages');
                //选中当前的page...
                for (let i=0;i<arrayNewPagesData.length;i++){
                    if (arrayNewPagesData[i].key == linkInfo.id){
                        arrayNewPagesData[i].isSelected = true;
                        arrayNewPagesData[i].icon = <IconPageCheck/>
                    }else{
                        arrayNewPagesData[i].isSelected = false;
                        arrayNewPagesData[i].icon = <IconPageBlack/>
                    }
                }
            }else if (linkInfo.type == LINK_INFO_TYPE_NOTE){
                setTableKey('notes');
                setIsShowPageLibrary(true);
                setLibraryType('card');
            }else if (linkInfo.type == LINK_INFO_TYPE_FRAME){
                setTableKey('frames');
            }else if (linkInfo.type == LINK_INFO_TYPE_PDF){
                setTableKey('pdfs');
                setIsShowPageLibrary(true);
                setLibraryType('pdf');
            }
            const arrayPages0 = arrayNewPagesData.filter(p=>p.key == linkInfo.pageId);
            if (arrayPages0.length > 0){
                setPageFrameTree(arrayPages0[0]);
            }
            setInputUrl(mszInputUrl);
        }else{
            mszInputUrl = '';
            if (linkInfo){
                setHasLink(true);
            }
            setInputUrl(linkInfo || '');
        }

        if (isEmbeddableElement(element)){
            setIsShowPageSelected(false);
            mszInputUrl = element.link;
            setInputUrl(mszInputUrl);
        }

        loopAllNode(arrayNewPagesData,(item)=>{
            if (item.isFolder || item.children){
                item.icon = <IconTreeFolderCollapse/>
            }else{
                item.icon = <IconBoard/>
            }
        })

        setArrayPagesData(arrayNewPagesData);
        setArrayPagesPdfData([...arrayNewPagesData]);
        setArrayNotesData(arrayNotesData);

        getProjectTree();
        if (szTabKey == 'library'){
            setTimeout(()=>{
                searchData(mszInputUrl)
            },200)
        }

        setTimeout(()=>{
            inputRef.current?.focus();
        },200);
    }

    /**
     * card/journal进入的
     * @param link
     * @param from
     */
    const onShowDialog = (link:any,from:any,extra:any)=>{
        setFrom(from);
        setInputUrl(link || '');
        setHasLink(link);
        setExtra(extra);

        // if (isDeepLink(link)){
        //     const deeplink = decodeDeeplink(link);
        //     if (deeplink.type == 'project'){
        //
        //     }else if (deeplink.type == 'library'){
        //
        //     }
        // }

        let szTabKey = localStorage.getItem(KEY_LINK_CARD_TAB) || 'project';
        if (extra?.from == "linkExistCard"){
            szTabKey = "library";
        }
        setTableKey(szTabKey);
        mTabKey = szTabKey;
        getProjectTree();
        if (szTabKey == 'library'){
            if (link){
                setTimeout(()=>{
                    searchData(link || '')
                },200)
            }
        }

        setTimeout(()=>{
            inputRef.current?.focus();
        },200);
    }

    const setPageFrameTree = (page:any)=>{
        mPageId = page.key;
        const arrayFrames = page.drawJson.elements.filter(p=>p.type == 'frame');
        frameElementsToTreeItem(arrayFrames);
    }

    //frame 中的element ---> tree
    const frameElementsToTreeItem = (arrayFrames:any)=>{
        mArrayFrames.current = [];
        arrayFrames.forEach(p=>{
            const itemNew = {
                title: p.name,
                editValue: p.name,
                key: p.id,
                icon: <IconFrame/>,
                isFolder: false,
                isEditable: false,
                element: p
            };
            mArrayFrames.current.push(itemNew);
        })

        setArrayFramesData(mArrayFrames.current);
    }

    /**
     * 项目树
     */
    const getProjectTree = ()=>{
        getNoteList().then(async (res)=>{
            var arrayNewTreeData:any = [];
            mArrayAllTreeData = [];
            for (let i=0;i<res.length;i++){
                const item = res[i];
                const jsonDoc = await getNoteJsonDoc(item.id);
                if (!jsonDoc)continue;
                const treeData = {
                    id:item.id,
                    key:item.id,
                    title:item.name,
                    icon:null,
                    isProject:true
                }
                if (jsonDoc.canvas?.length > 1){
                    treeData.children = [];

                    loopAllNode(jsonDoc.canvas,(node)=>{
                        node.isChild = true;
                        node.id = item.id
                    })
                    treeData.children.push(...jsonDoc.canvas);
                    // for (let j=0;j<jsonDoc.canvas.length;j++){
                    //     treeData.children.push({
                    //         isChild:true,
                    //         id:item.id,
                    //         key:jsonDoc.canvas[j].key,
                    //         title:jsonDoc.canvas[j].title,
                    //         parentTitle:item.name
                    //     })
                    // }
                }
                arrayNewTreeData.push(treeData);
                mArrayAllTreeData.push(treeData);
            }

            setArrayTreeData(arrayNewTreeData);

            onSetTreeHover();
        })
    }

    //pdf部分
    const setPagePdfTree = (page:any)=>{
        mPdfPageId = page.key;
        const arrayPdfs = page.drawJson.elements.filter(p=>isPdfFileElement(p));
        pdfElementsToTreeItem(arrayPdfs);
    }
    const pdfElementsToTreeItem = (arrayPdfs:any)=>{
        mArrayPdfs = [];
        arrayPdfs.forEach(p=>{
            const itemNew = {
                title: p.customData.generationData.showName,
                editValue: p.customData.generationData.showName,
                key: p.id,
                icon: <IconPdf/>,
                isFolder: false,
                isEditable: false,
                fileName:p.customData.generationData.fileName,
                element: p
            };
            mArrayPdfs.push(itemNew);
        })

        setArrayPdfsData(mArrayPdfs);
    }

    const onTabChanged = (activeKey)=>{
        mTabKey = activeKey;
        setTableKey(activeKey);
        if (from == 'card' || from == 'from_mindmap'){
            localStorage.setItem(KEY_LINK_CARD_TAB,activeKey);
        }else{
            localStorage.setItem(KEY_LINK_TAB,activeKey);
        }

        setIsShowPageLibrary(false);
        if (activeKey == 'notes'){
            setIsShowPageLibrary(true);
            setLibraryType('card');
        }else if (activeKey == 'pdfs'){
            setIsShowPageLibrary(true);
            setLibraryType('pdf')
        }else if (activeKey == 'project'){
            onSetTreeHover();
            searchData(mszInputUrl);
        }else if (activeKey == 'library'){
            searchData(mszInputUrl);
        }
    }

    const onPagesExpand: TreeProps["onExpand"] = ((expandedKeys: any, expanded) => {
        //修改文件夹样式
        const arrayNewData = [...arrayPagesData];
        loopAllNode(arrayNewData,(item)=>{
            if (item.isFolder){
                if (expandedKeys.includes(item.key)){
                    item.icon = <IconTreeFolderExpand/>
                }else{
                    item.icon = <IconTreeFolderCollapse/>
                }
            }
        })
        setArrayPagesData(arrayNewData);

        setExpandPagesKeys(expandedKeys);
    })

    /**
     * page 选择.....
     */
    const onPagesSelect: TreeProps["onSelect"] = ((selectedKeys: any, info) => {
        console.log(selectedKeys);
        console.log(info);
        if (info.node.isFolder || info.node.children)return;

        const linkInfo = {
            type:LINK_INFO_TYPE_PAGE,
            id:selectedKeys[0],
            url:info.node.title//标题或笔记的名称/或输入的URL
        }
        if (mElement){
            if (!isStringNullOrEmpty(mElement.frameId)){
                message.info(t("Objects in a frame"));
                return;
            }

            props.onInsertLink(linkInfo);
        }else{
            const library = {
                id:info.node.key,
                name:info.node.title
            }
            // const szLinkInfo = createCopyLink('project',PROJECT_ID,'board',library.id);
            //发消息当前link
            postMessage(EVENT_MINDMAP_LINK_INFO,{linkInfo:JSON.stringify(linkInfo),library:library})
        }

        props.onCloseDialog();
    });


    const onNotesExpand: TreeProps["onExpand"] = ((expandedKeys: any, expanded) => {
        setExpandPagesKeys(expandedKeys);
    })
    /**
     * tree选择.....
     */
    const onNotesSelect: TreeProps["onSelect"] = ((selectedKeys: any, info) => {
        // console.log(selectedKeys);
        // console.log(info)
        const linkInfo = {
            type:LINK_INFO_TYPE_NOTE,
            id:selectedKeys[0],
            url:info.node.title
        }
        if (mElement){
            props.onInsertLink(linkInfo);
        }else{
            //发消息当前link
            postMessage(EVENT_MINDMAP_LINK_INFO,{linkInfo:JSON.stringify(linkInfo)})
        }

        props.onCloseDialog();
    });

    /**
     * frame 链接
     */
    const onFrameSelect:TreeProps["onSelect"] = ((selectedKeys: any, info) => {
        console.log(selectedKeys);
        console.log(info);
        const linkInfo = {
            type:LINK_INFO_TYPE_FRAME,
            pageId:mPageId,
            id:selectedKeys[0],
            url:info.node.title//标题或笔记的名称/或输入的URL
        }
        if (mElement){
            //只有frame内的元素才可以链接到frame...
            if (isStringNullOrEmpty(mElement.frameId) && mElement.type != 'frame'){
                message.info(t("Only objects in a frame"));
                return;
            }
            if (mElement.frameId == info.node.key){
                message.error(t("Invalid operation"));
                return;
            }
            props.onInsertLink(linkInfo);
        }else{
            const library = {
                id:info.node.key,
                name:info.node.title
            }
            //发消息当前link
            postMessage(EVENT_MINDMAP_LINK_INFO,{linkInfo:JSON.stringify(linkInfo),library:library})
        }

        props.onCloseDialog();
    });

    /**
     * pdf 链接选择
     */
    const onPdfSelect:TreeProps["onSelect"] = ((selectedKeys: any, info) => {
        // console.log(selectedKeys);
        // console.log(info);
        const linkInfo = {
            type:LINK_INFO_TYPE_PDF,
            pageId:mPdfPageId,
            id:selectedKeys[0],
            url:info.node.title,//标题或笔记的名称/或输入的URL,
            fileName:info.node.fileName
        }
        if (mElement){
            props.onInsertLink(linkInfo);
        }else{
            //发消息当前link
            postMessage(EVENT_MINDMAP_LINK_INFO,{linkInfo:JSON.stringify(linkInfo)})
        }

        props.onCloseDialog();
    });

    const onInputChanged = (e)=>{
        mszInputUrl = e.currentTarget.value.toLowerCase();
        setInputUrl(e.currentTarget.value);

        //清除上一次的计时
        clearTimeout(mLastSearchTimeoutId.current);
        setIsSearching(true);
        mLastSearchTimeoutId.current = setTimeout(()=>{
            searchData(mszInputUrl);
            clearTimeout(mLastSearchTimeoutId.current);
        },1500);


    }

    const isUrl = (szKey:any)=>{
        if (szKey.startsWith('http://') || szKey.startsWith("noteey://") || szKey.startsWith("https://")){
            return true;
        }
        return false;
    }

    /**
     * 搜索数据
     * @param szKey
     */
    const searchData = (szKey:any)=>{

        let szNewKey = isUrl(szKey)?'':szKey;
        szNewKey = szNewKey?.toLowerCase();
        //search pages...
        const arrayNewPages:any = filterTreeData(szNewKey,mArrayPages);
        setArrayPagesData(arrayNewPages);
        setArrayPagesPdfData([...arrayNewPages]);

        const arrayNewNotes = filterTreeData(szNewKey,mArrayNotes);
        setArrayNotesData(arrayNewNotes);

        setAutoExpandPagesParent(true);

        if (mTabKey == 'project'){
            var arrayNewTreeData:any = [];
            if (!szNewKey) {
                arrayNewTreeData.push(...mArrayAllTreeData);
            }else {
                for (let i = 0; i < mArrayAllTreeData.length; i++) {
                    const item = mArrayAllTreeData[i];
                    let newItem:any = null;
                    if (item.title.toLowerCase().includes(szNewKey)) {
                        newItem = {...item};
                        // delete newItem.children;
                    }else if (item.children) {
                        for (let j=0;j<item.children.length;j++) {
                            if (item.children[j].title.toLowerCase().includes(szNewKey)) {
                                if (newItem) {
                                    if (!newItem.children) {
                                        newItem.children = [];
                                    }
                                }else {
                                    newItem = {...item};
                                    newItem.children = [];
                                }
                                newItem.children.push({...item.children[j]})
                            }
                        }
                    }
                    if (newItem) {
                        arrayNewTreeData.push(newItem);
                    }
                }
            }

            setArrayTreeData(arrayNewTreeData);
            setIsSearching(false);

        }else if (mTabKey == 'library'){
            setTimeout(()=>{
                pageLibraryRef.current?.onSearchEvent(szNewKey,true,()=>{
                    setIsSearching(false);//搜索结束
                });
            },200)
        }else if (mTabKey == 'frames'){
            const arrayNewFrame:any = [];
            if (szNewKey){
                for (let i=0;i<mArrayFrames.current.length;i++){
                    const f = mArrayFrames.current[i];
                    if (f.title && f.title?.toLowerCase().includes(szNewKey)){
                        arrayNewFrame.push(f);
                    }
                }
            }else{
                arrayNewFrame.push(...mArrayFrames.current);
            }
            setArrayFramesData(arrayNewFrame);
            setIsSearching(false);
        }
    }

    const filterTreeData = (szKey,arrayTreeData)=>{

        var arrayPages = [];
        for (var i=0;i<arrayTreeData.length;i++){
            var item = arrayTreeData[i];
            var arrayChilds = [];
            if(item.isFolder){
                for(var j=0;j<item.children.length;j++){
                    var childItem = item.children[j];
                    if (childItem.title.toLowerCase().indexOf(szKey) >= 0){
                        arrayChilds.push(childItem);
                    }
                }
                if(arrayChilds.length > 0){
                    var newItem = {...item};
                    newItem.children = arrayChilds;
                    arrayPages.push(newItem);
                }
            }else{
                if(item.title.toLowerCase().indexOf(szKey) >= 0){
                    arrayPages.push(item);
                }
            }
        }
        return arrayPages;
    }

    /**
     * 移除链接
     */
    const onRemoveLink = ()=>{
        /*
        Modal.confirm({
            content:'Confirm remove link',
            onOk(){
                props.onInsertLink(null);
                props.onCloseDialog();
            }
        })

         */
        dialogMessageBoxRef.current?.onShowDialog(t("Tips"),t("Confirm remove link"),t("Remove"),()=>{
            if (mElement || from == 'card'){
                props.onInsertLink(null);
            }else{
                postMessage(EVENT_MINDMAP_LINK_INFO,{linkInfo:''})
            }
            props.onCloseDialog();
        })
    }

    /**
     * 保存链接
     */
    const onSaveLink = async ()=>{
        let szUrl = inputUrl;

        if (!isValidUrl(szUrl) && (isPdf(szUrl) || isVideo(szUrl) || isImage(szUrl) || isAudio(szUrl))){
            //当前库是绝对路径是否有当前
            // let library = await getLibraryByFileName(inputUrl);
            // if (!library){
            //     library = await insertLibraryByLinkMode(inputUrl);
            // }
            let library = await insertLibraryByLinkMode(szUrl);
            if (library){
                szUrl = createCopyLinkByLibraryItem(library,false);
            }
        }
        if (from == 'from_mindmap') {
            postMessage(EVENT_MINDMAP_LINK_INFO,{linkInfo:szUrl,library:{name:''}});
            props.onCloseDialog();
            return;
        }

        if(props.onInsertLink){
            //如果是文件--添加到库..--如果是文件直接添加到库。难判断--每次确定都可能会被加到库，。。不要了。。
            if (from == 'card' && !mIsFolder){
                // const library = await insertLibraryByLinkMode(inputUrl);
                // if (library){
                //     szUrl = createCopyLinkByLibraryItem(library,false);
                // }
            }
            mIsFolder = false;
            props.onInsertLink(szUrl);
            props.onCloseDialog();
            return;
        }

        if (mElement && mElement.link){
            if (mElement.link.startsWith('{')){
                const linkInfo = JSON.parse(mElement.link);
                if (linkInfo.url == inputUrl){
                    //没有变化，什么也不做.
                    props.onCloseDialog();
                    return;
                }
            }
        }
        const item = {
            type:LINK_INFO_TYPE_URL,
            id:'',
            url:inputUrl
        }
        if (mElement){
            if (isEmbeddableElement(mElement)){
                props.onInsertLink(inputUrl);
            }else{
                props.onInsertLink(item);
            }
        }else{
            postMessage(EVENT_MINDMAP_LINK_INFO,{linkInfo:JSON.stringify(item)})
        }

        props.onCloseDialog();
    }

    const onSetTreeHover = ()=>{
        setTimeout(()=>{
            const div = document.getElementById('shit-tree-dialog-link');
            if (div){
                const arrayShitTrees = div.getElementsByClassName('ant-tree-list-holder-inner');
                for (let i=0;i<arrayShitTrees.length;i++){
                    const ddddd = arrayShitTrees[i];
                    ddddd.classList.add(isDarkMode()?'ant-tree-list-holder-inner-shit-ant-tree-dark':'ant-tree-list-holder-inner-shit-ant-tree-light')
                }
            }
        },100)
    }

    const onSelect:TreeProps["onSelect"] =(async (selectedKeys:any, info) => {
        if (!info.node.isProject && (info.node.children || info.node.isFolder))return;

        //创建链接，插入
        let szDeeplink = '';
        //发消息当前link
        const library = {
            id:info.node.id,
            name:info.node.title
        }
        if (!info.node.isProject){
            szDeeplink = createCopyLink('project',info.node.id,'board',info.node.key,null,null,false,null);
            // library.name = info.node.parentTitle+'/'+info.node.title;
        }else{
            szDeeplink = createCopyLink('project',info.node.key,null,null,null,null,false,null);
        }
        if (from == 'from_mindmap') {
            postMessage(EVENT_MINDMAP_LINK_INFO,{linkInfo:szDeeplink,library:library});
            props.onCloseDialog();
        }else {
            //类型太多，这里普通的链接已经不能满足link的需求了。改为deeplink
            props.onInsertLink(szDeeplink);
            props.onCloseDialog();
        }
    });

    /**
     * 渲染列表
     */
    const renderPages = ()=>{

        if (tabKey == 'pages'){
            return renderPagesTree();
        }else if (tabKey == 'frames'){
            return renderFrameTree();
        }else if (tabKey == 'notes'){
            // return renderNotesTree();
            // setLibraryType('card');
        }else if (tabKey == 'pdfs'){
            // return renderPdfTree();
            // setLibraryType('pdf')
        }else if (tabKey == 'library'){
            return(
                <div style={{height:'480px',marginTop:'-12px'}}>
                    <PageLibrary ref={pageLibraryRef} from={FROM_LIBRARY} subFromPage={FROM_DIALOG} extra={extra} type={''} searchKey={mszInputUrl} szContainerId={generateUUID2()} isInsertNewLibrary={true} source={'dialogLink'} onItemSelectedCallback={(item:any)=>{
                        let szDeeplink = createCopyLinkByLibraryItem(item,false);
                        if (from == 'from_mindmap') {
                            //发消息当前link
                            postMessage(EVENT_MINDMAP_LINK_INFO,{linkInfo:szDeeplink,library:item});
                            props.onCloseDialog();
                        }else {
//类型太多，这里普通的链接已经不能满足link的需求了。改为deeplink
                            props.onInsertLink(szDeeplink);
                            props.onCloseDialog();
                        }
                    }}/>
                </div>
            )
        }else if (tabKey == 'project'){
            return(
                <div id={'shit-tree-dialog-link'} style={{padding:'0 20px'}}>
                    <ConfigProvider
                        theme={{
                            components: {
                                Tree: {
                                    /* 这里是你的组件 token */
                                    // nodeHoverBg:'#000000',
                                    colorBgContainer:'#000000'
                                },
                            },
                        }}
                    >
                        <DirectoryTree
                            style={{
                                height: '468px',
                                overflowY: 'auto',
                                overflowX: 'hidden',
                                background: isDarkMode()?'#1E1E1E':'transparent',
                                border:'1px solid var(--line-color)',
                                borderRadius:'8px'
                            }}
                            className={'overwrite-direction-tree tree-fuck-css-left-align-1'}
                            switcherIcon={<Icon component={() => <img className='img-10' style={{marginTop:'0px'}} src={getImagePathWithTheme('tree_icon')}/>}/>}
                            onSelect={onSelect}
                            showIcon={false}
                            treeData={arrayTreeData}
                            selectedKeys={[]}
                            blockNode={true}
                            titleRender={(nodeData: any) => {
                                return (
                                    <div className='' id={nodeData.key}
                                         style={{display: "flex", width: "450px", alignItems: "center"}}>
                                        <Input className='default-font-size font-family-regular hovered-text-white'
                                               readOnly={true} bordered={false}
                                               style={{
                                                   marginLeft: '0px',
                                                   paddingLeft: '0px',
                                                   whiteSpace: 'nowrap',
                                                   textOverflow: 'ellipsis',
                                                   overflow: 'hidden',
                                                   cursor: "pointer",
                                                   fontSize: '14px',
                                                   marginBottom: '0px',
                                                   marginTop: '0px',
                                               }}
                                               value={nodeData.title}/>
                                    </div>
                                )
                            }}
                        />
                    </ConfigProvider>
                </div>

            )
        }
    }


    const renderPagesTree = ()=>{
        return(
            <div className='font-size-12 tree-fuck-css-left-align-0' style={{overflow:'auto',height:'100%',margin:'0 0px 0 -12px'}}>
                <DirectoryTree
                    className="tree-fuck-css"
                    style={{height:'468px',marginLeft:'-2px'}}
                    switcherIcon={null}
                    onExpand={onPagesExpand}
                    onSelect={onPagesSelect}
                    selectedKeys={treePageSelectedKeys}
                    treeData={arrayPagesData}
                    autoExpandParent={autoExpandPagesParent}
                    showIcon={true}
                    blockNode={true}
                    titleRender={(nodeData: any) => {
                        return (
                            <div style={{display: "flex", width: "100%", alignItems: "center",marginTop:'0px'}}>
                                <Input readOnly={true} bordered={false}
                                       className='font-family-regular font-size-12'
                                       style={{
                                           color: (treePageSelectedKeys[0] == nodeData.key) ? "var(--text-color)" : "var(--text-color)",
                                           marginLeft: '0px',
                                           paddingLeft: '0px',
                                           cursor: "pointer",
                                           flexGrow: 1
                                       }}
                                       value={nodeData.title}/>

                            </div>
                        )
                    }}
                />
            </div>
        )
    }

    const renderFrameTree = ()=>{
        return(
            <div style={{height:'468px',width:'100%',margin:'0 20px'}}>
                <Select className='font-size-12' style={{width:'calc(100% - 40px)'}}
                        value={framePageValue}
                        optionLabelProp = {'showLabel'}
                        suffixIcon={<IconDropdownBlack/>}
                        onChange={(value)=>{
                            setFramePageValue(value);
                            const arrayElements = arrayPagesData.filter(p=>p.key == value);
                            if (arrayElements.length > 0) {
                                setPageFrameTree(arrayElements[0]);
                            }
                        }}
                        dropdownClassName='font-size-12'
                    options={arrayPagesData}/>
                <div style={{overflowX:'hidden',overflowY:'auto',marginTop:'12px'}}>
                    <DirectoryTree
                        className="tree-fuck-css"
                        style={{height:'276px',marginLeft:'-25px'}}
                        switcherIcon={<CaretDownOutlined rev={undefined}/>}
                        onSelect={onFrameSelect}
                        selectedKeys={treeFrameSelectedKeys}
                        treeData={arrayFramesData}
                        showIcon={true}
                        blockNode={true}
                        titleRender={(nodeData: any) => {
                            return (
                                <div className='font-size-12' style={{display: "flex", width: "300%", alignItems: "center",marginTop:'-0px'}}>
                                    <Input readOnly={true} bordered={false}
                                           className='font-family-regular'
                                           style={{
                                               color: (treeFrameSelectedKeys[0] == nodeData.key) ? "var(--text-color)" : "var(--text-color)",
                                               marginLeft: '0px',
                                               paddingLeft: '0px',
                                               cursor: "pointer",
                                               flexGrow: 1
                                           }}
                                           value={nodeData.title}/>

                                </div>
                            )
                        }}
                    />
                </div>
            </div>
        )
    }

    const renderNotesTree = ()=>{
        return(
            <div style={{overflowY:'auto',height:'100%',overflowX:'hidden'}}>
                <DirectoryTree
                    className="tree-fuck-css"
                    style={{height:'500px',marginLeft:'-25px',width:'200%'}}
                    switcherIcon={<CaretDownOutlined rev={undefined}/>}
                    onExpand={onNotesExpand}
                    onSelect={onNotesSelect}
                    selectedKeys={treeNoteSelectedKeys}
                    treeData={arrayNotesData}
                    showIcon={true}
                    blockNode={true}
                    titleRender={(nodeData: any) => {
                        return (
                            <div className='font-size-12' style={{display: "flex", width: "290%", alignItems: "center",marginTop:'-0px',overflowX:'hidden'}}>
                                <Input readOnly={true} bordered={false}
                                       className='font-family-regular'
                                       style={{
                                           color: (treeNoteSelectedKeys[0] == nodeData.key) ? "var(--text-color)" : "var(--text-color)",
                                           marginLeft: '0px',
                                           paddingLeft: '0px',
                                           cursor: "pointer",
                                           flexGrow: 1
                                       }}
                                       value={nodeData.title == t("Untitled")?getNoteFirstHtmlForLeftCard(nodeData.noteDataDoc):nodeData.title}/>

                            </div>
                        )
                    }}
                />
            </div>
        )
    }

    const renderPdfTree = ()=>{
        return(
            <div style={{height:'500px',width:'100%'}}>
                <Select className='font-size-12' style={{width:'100%'}}
                        value={pdfPageValue}
                        optionLabelProp = {'showLabel'}
                        suffixIcon={<IconDropdownBlack/>}
                        onChange={(value)=>{
                            setPdfPageValue(value);
                            const arrayElements = arrayPagesPdfData.filter(p=>p.key == value);
                            if (arrayElements.length > 0) {
                                setPagePdfTree(arrayElements[0]);
                            }
                        }}
                        dropdownClassName='font-size-12'
                        options={arrayPagesPdfData}/>
                <div style={{overflowX:'hidden',overflowY:'auto',marginTop:'12px'}}>
                    <DirectoryTree
                        className="tree-fuck-css"
                        style={{height:'276px',marginLeft:'-25px'}}
                        switcherIcon={<CaretDownOutlined rev={undefined}/>}
                        onSelect={onPdfSelect}
                        selectedKeys={treePdfSelectedKeys}
                        treeData={arrayPdfsData}
                        showIcon={true}
                        blockNode={true}
                        titleRender={(nodeData: any) => {
                            return (
                                <div className='font-size-12' style={{display: "flex", width: "300%", alignItems: "center",marginTop:'-0px'}}>
                                    <Input readOnly={true} bordered={false}
                                           className='font-family-regular'
                                           style={{
                                               color: (treePdfSelectedKeys[0] == nodeData.key) ? "var(--text-color)" : "var(--text-color)",
                                               marginLeft: '0px',
                                               paddingLeft: '0px',
                                               cursor: "pointer",
                                               flexGrow: 1
                                           }}
                                           value={nodeData.title}/>

                                </div>
                            )
                        }}
                    />
                </div>
            </div>
        )
    }

    return(
        <ConfigProvider
            theme={{
                components: {
                    Modal: {
                        /* 这里是你的组件 token */
                        contentBg:'var(--home-left-background-color)',
                    },
                },
            }}>
            <Modal open={props.isShowDialog}
                   onCancel={()=>{
                       global.g_showDialogs.dialogLink = false;
                       props.onCloseDialog();
                   }}
                   afterOpenChange={(e)=>{
                       global.g_showDialogs.dialogLink = e;
                   }}
                   centered={true}
                   zIndex={MAX_Z_INDEX}
                   width={isShowPageSelected?'956px':'456px'}
                   bodyStyle={{height:isShowPageSelected?'710px':'180px',overflow:'visible',margin:'-20px -24px'}}
                   destroyOnClose={true}
                   closeIcon={<IconCloseBlack/>}
                   maskClosable={true} footer={null} closable={true}>
                <div style={{overflow:'visible',padding:'20px 0 0 0'}}>
                    <span className='font-family-medium' style={{fontSize:'14px',marginLeft:'20px'}}>{t("Search or enter a URL")}</span>
                    <div className='line-e4-tb-16'></div>
                    <div className='input-border flex-row-vertical-center' style={{margin:'0 20px',background:'var(--input-background-color)!important'}}>
                        <input ref={inputRef} style={{marginTop: '0px',border:'none',outline:'none',flexGrow:'1',paddingLeft:'8px',background:'transparent'}} className='font-family-regular font-size-12'
                               onChange={onInputChanged} placeholder={''} value={inputUrl} onPaste={(event)=>{
                                   if(event.clipboardData.files.length > 0) {
                                       event.preventDefault();
                                   }
                        }}/>

                        {
                            isSearching &&
                            <Spin indicator={<img className={'img-16 rotating-image'}
                                                  src={getImagePathWithTheme('indicator_black')}/>} size={'small'}/>
                        }
                        {
                            !APP_WEB_WWW && !APP_WEB && isShowPageSelected &&
                            <Tooltip placement="bottom" fresh={true} color='#808080' zIndex={MAX_Z_INDEX} overlayClassName='font-size-12' title={t("CreateLinkToLocal")} arrow={true}>
                                <Dropdown trigger={["click"]} overlayStyle={{zIndex:`${MAX_Z_INDEX}`}} menu={{items:MENU}}>
                                    <img className='img-18 mr-10 cursor-pointer ml-12'
                                         src={imgPathPerfix() + 'local_file.png'}/>
                                </Dropdown>
                            </Tooltip>
                        }
                    </div>

                    <div style={{display: isShowPageSelected ? 'inherit' : 'none'}}>
                        {/*<div className='font-size-12 font-family-medium'*/}
                        {/*     style={{margin:'16px 20px 0px 20px'}}>{t("Content in the project")}</div>*/}
                        {
                                <>
                                    <ConfigProvider
                                        theme={{
                                            components: {
                                                Tabs: {
                                                    /* 这里是你的组件 token */
                                                    fontSize: 12
                                                },
                                            },
                                        }}
                                >
                                    <Tabs style={{margin:'12px 20px'}} className='font-size-12' items={from == 'card'?tabItemsFromCard:tabItems} activeKey={tabKey} onChange={onTabChanged}/>
                                </ConfigProvider>

                                <div style={{paddingTop:'6px',height:'100%'}}>
                                    {renderPages()}
                                </div>
                            </>
                        }


                        {
                            isShowPageLibrary &&
                            <div style={{marginTop:'-12px',height:'480px'}}>
                                <PageLibrary ref={pageLibraryRef} from={FROM_ADD} type={libraryType} subFromPage={'DialogLink'} isInsertNewLibrary={true} extra={extra} szContainerId={generateUUID2()} source={'dialogLink'}  onItemSelectedCallback={(item:any)=>{
                                    if (item.type == 'add') {
                                        if (tabKey == 'notes') {
                                            Global.g_currentNoteData = {id: generateRandomPageKey()}
                                            openEditor(Global.g_currentNoteData.id, true, false);
                                            window.eventAddChooseCard = (note: any) => {
                                                // var arrayNew = [...arrayDatas];
                                                // var item = {
                                                //     id: note.id,
                                                //     type: 'card',
                                                //     name: note.name,
                                                //     doc: note.doc,
                                                // }
                                                // updateCard(item);
                                                // arrayNew.push(item);
                                                // setArrayDatas(arrayNew);
                                                //直接插入并关闭
                                                // setIsShowDialog(false);
                                                // setTimeout(() => {
                                                //     props.onOkEvent(item);
                                                // }, 10)
                                            }
                                        } else if (tabKey == 'pdfs') {
                                            postMessage(EVENT_CHOOSE_INSERT_PDF_FILE);
                                            window.eventAddChoosePdf = (item: any) => {
                                                // var arrayNew = [...arrayDatas];
                                                // arrayNew.push(item);
                                                // setArrayDatas(arrayNew);
                                                //直接插入这个并关闭
                                                // setIsShowDialog(false);
                                                setTimeout(() => {
                                                    props.onOkEvent(item);
                                                }, 10)
                                            }
                                        }
                                    }else {
                                        //添加这个link....
                                        if (tabKey == 'notes') {
                                            const linkInfo = {
                                                type:LINK_INFO_TYPE_NOTE,
                                                id:item.id,
                                                url:item.name
                                            }
                                            if (mElement){
                                                props.onInsertLink(linkInfo);
                                            }else{
                                                //发消息当前link
                                                postMessage(EVENT_MINDMAP_LINK_INFO,{linkInfo:JSON.stringify(linkInfo)})
                                            }

                                            props.onCloseDialog();
                                        }else if (tabKey == 'pdfs') {
                                            const linkInfo = {
                                                type:LINK_INFO_TYPE_PDF,
                                                // pageId:mPdfPageId,
                                                id:item.id,
                                                url:item.name,//标题或笔记的名称/或输入的URL,
                                                fileName:item.fileName
                                            }
                                            if (mElement){
                                                props.onInsertLink(linkInfo);
                                            }else{
                                                //发消息当前link
                                                postMessage(EVENT_MINDMAP_LINK_INFO,{linkInfo:JSON.stringify(linkInfo)})
                                            }

                                            props.onCloseDialog();
                                        }
                                    }
                                }}/>
                            </div>

                        }
                    </div>

                    <div className='flex-center' style={{marginTop:isShowPageSelected?'12px':'16px',marginBottom:'1px',flexShrink:'0'}}>
                        {
                            hasLink &&
                            <Button style={{minWidth:'164px'}} className='button-border-gray-style' onClick={onRemoveLink}>{t("Delete")}</Button>
                        }

                        <Button type={"primary"} style={{minWidth:'164px'}} className={hasLink? 'ml-16':'' + 'button-solid-style ml-16'} onClick={onSaveLink}>{t("Confirm")}</Button>
                    </div>

                    <DialogMessageBox ref={dialogMessageBoxRef}/>
                </div>
            </Modal>
        </ConfigProvider>
    )
});

export default React.memo(DialogLink);